import { CustomIcon } from "components/icon/customIcon.component";
import { CustomLink } from "components/Typography/text.styled";
import { Color } from "config/colors";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { useAuthStore } from "stores/authStore/authStore";
import { useEmployeeStore } from "web-apps/employee/stores/employeeStore/employeeStore";
import Logo from "../../../images/logo/svg/simflexity-logo.svg";
import { MenuItem, useMenuList } from "../menu-utils";
import { MenuItemsEmployee } from "../menuList/menuItemsEmployee.component";
import { NavBarMenuListStyled } from "../menuList/navBarMenuList.styled";
import { Burger, Flex1, LogInWrapper, NavBarStyled } from "./navBar.styled";

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const NavBar: React.FC<Props> = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [authState, authActions] = useAuthStore();
  const [menuList, setMenuList] = useState<MenuItem[]>([]);
  const [employeeState, , employeeDispatch] = useEmployeeStore();
  const menu = useMenuList(authState.accountType, t);

  useEffect(() => {
    setMenuList(menu);
  }, [menu]);

  const handleClick = async () => {
    authActions.signOut().then(() => {
      employeeDispatch({ type: "CLEAR_EMPLOYEE_INFORMATION" });
      history.push("/employee/login");
      setOpen(!open);
    });
  };

  return (
    <NavBarStyled $isStampClockRoute={false}>
      <Link to="/employee/schedule">
        <img src={Logo} alt="Logo" style={{ height: 50 }} />
      </Link>
      <Flex1>
        <NavBarMenuListStyled>
          {employeeState.employee && (
            <MenuItemsEmployee
              menuList={menuList}
              open={open}
              setOpen={setOpen}
            />
          )}
        </NavBarMenuListStyled>
      </Flex1>
      <LogInWrapper>
        {authState.signedIn && employeeState.employee ? (
          <CustomLink onClick={handleClick} color={Color.Destructive}>
            {t("ProfileCompany.SignOut")}
          </CustomLink>
        ) : (
          <>
            <CustomLink to="/employee/login" color={Color.MidnightBlue}>
              {t("LoginCompany.EmployeeLogin")}
            </CustomLink>
            <CustomLink to="/company/login" color={Color.Destructive}>
              {t("LoginCompany.CompanyLogin")}
            </CustomLink>
          </>
        )}
      </LogInWrapper>
      <Burger>
        <CustomIcon
          name="hamburger"
          size="40px"
          onClick={() => {
            setOpen(!open);
          }}
        />
      </Burger>
    </NavBarStyled>
  );
};
